import React, { useEffect, useState } from 'react';
import { ListarRondasReport } from '../../services/api';
import { peDate, peTime, parseApiError } from '../../util/util';
import { Cargando } from '../Cargando';
import ModalReporteRondas from './ModalRondas/ModalReporteRondas';
import { minutesDiffDisplay } from '../../helper/dateHelper';

export default function ListadoRondasPorAsignacion({ assignment, assignmentId, startDate, endDate, userId, token }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  const [selectedRound, setSelectedRound] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (round) => {
    setSelectedRound(round);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRound(null);
  };

  useEffect(() => {
    let alive = true;

    if (!assignmentId || !startDate || !endDate || !userId) {
      setRows([]);
      setErrorMsg('');
      setLoading(false);
      return () => { alive = false; };
    }

    (async () => {
      setLoading(true);
      setErrorMsg('');
      setRows([]);
      try {
        const data = await ListarRondasReport({
          startDate,
          endDate,
          userId,
          assignmentId,
          token,
        });
        console.log(data)
        if (!alive) return;
        setRows(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!alive) return;
        console.error(err);
        setRows([]);
        setErrorMsg(parseApiError(err, 'No se pudieron listar las rondas.'));
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [assignmentId, startDate, endDate, userId, token]);

  if (loading) return <div className="py-3 text-center"><Cargando /></div>;

  return (
    <div className="table-responsive">
      <table className="table table-sm mb-0">
        <thead className='text-center'>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Fecha planificada</th>
            <th>Horario planificada</th>
            <th>Fecha ejecutada</th>
            <th>Horario ejecutada</th>
            <th>Tiempo (Minutos)</th>

            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody className='text-center'>
          {errorMsg ? (
            <tr><td colSpan={6} className="text-center text-danger">{errorMsg}</td></tr>
          ) : rows.length === 0 ? (
            <tr><td colSpan={6} className="text-center">Sin rondas</td></tr>
          ) : rows.sort((a, b) => Date.parse(b.endDatePlanning) - Date.parse(a.initDatePlanning)).map((r, index) => (


            // console.log(Date.parse(r.initDatePlanning)),
            <tr key={r.id}>
              <td>{index + 1}</td>
              <td>{r.id.slice(0, 8).toUpperCase()}</td>
              <td>{peDate(r.initDatePlanning)}</td>
              <td>{peTime(r.initDatePlanning) + ' - ' + peTime(r.endDatePlanning)}</td>
              <td>{peDate(r.initHourExecuted)}</td>
              <td>{peTime(r.initHourExecuted) + ' - ' + peTime(r.endHourExecuted)}</td>
              <td>{minutesDiffDisplay(r.initHourExecuted, r.endHourExecuted) || "0"}</td>
              <td>{r.state === 3 ? 'Finalizada' : '' || r.state === 4 ? 'Emergencia' : ''}</td>
              <td className="text-end">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => handleOpenModal(r)}
                  title="Ver detalle de la ronda"
                >
                  <i className="bi bi-person-gear"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showModal && (
        <ModalReporteRondas
          show={showModal}
          onClose={handleCloseModal}
          round={selectedRound}
          assignment={assignment}
        />
      )}
    </div>
  );
}
